import { OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
var CreateReservationIntervalComponent = /** @class */ (function () {
    function CreateReservationIntervalComponent(fb, translate) {
        this.fb = fb;
        this.translate = translate;
        /**
         * Event raised on click on "Go!"
         *
         * @memberof CreateReservationIntervalComponent
         */
        this.datesGenerated = new EventEmitter();
        /**
         * number of items dropdown values
         *
         * @type {IMultiDropdownData[]}
         * @memberof CreateReservationIntervalComponent
         */
        this.selectNumberItemsValues = [];
        /**
         * interval dropdown values
         *
         * @type {IMultiDropdownData[]}
         * @memberof CreateReservationIntervalComponent
         */
        this.selectIntervalValues = [];
        this.createForm();
        this.initSelectIntervalValues();
        this.initSelectNumberItemsValues();
    }
    CreateReservationIntervalComponent.prototype.ngOnInit = function () {
    };
    /**
     * Handle click on "Go"
     *
     * @memberof CreateReservationIntervalComponent
     */
    CreateReservationIntervalComponent.prototype.onGoClick = function () {
        var interval;
        switch (this.selectedInterval) {
            case Interval.DAY:
                interval = 1;
                break;
            case Interval.WEEK:
                interval = 7;
                break;
            case Interval.TWO_WEEK:
                interval = 14;
                break;
        }
        var out = [];
        for (var i = 0; i < this.selectedNumberItems; i++) {
            out[i] = new Date(this.startDate);
            out[i].setDate(out[i].getDate() + interval * (i + 1));
        }
        this.datesGenerated.emit(out);
    };
    Object.defineProperty(CreateReservationIntervalComponent.prototype, "selectedInterval", {
        get: function () {
            return Number(this.formGroup.get('interval').value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationIntervalComponent.prototype, "selectedNumberItems", {
        get: function () {
            return Number(this.formGroup.get('numberItems').value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Create the form
     *
     * @private
     * @memberof CreateReservationIntervalComponent
     */
    CreateReservationIntervalComponent.prototype.createForm = function () {
        this.formGroup = this.fb.group({
            numberItems: new FormControl('1', [
                Validators.required
            ]),
            interval: new FormControl(Interval.WEEK, [
                Validators.required
            ]),
        });
    };
    /**
     * Init number of items dropdown
     *
     * @private
     * @memberof CreateReservationIntervalComponent
     */
    CreateReservationIntervalComponent.prototype.initSelectNumberItemsValues = function () {
        for (var i = 1; i <= 50; i++) {
            this.selectNumberItemsValues.push({ key: String(i), text: String(i), selected: null });
        }
    };
    /**
     * Init interval dropdown
     *
     * @private
     * @memberof CreateReservationIntervalComponent
     */
    CreateReservationIntervalComponent.prototype.initSelectIntervalValues = function () {
        var _this = this;
        var values = [
            Interval.DAY,
            Interval.WEEK,
            Interval.TWO_WEEK
        ];
        values.forEach(function (x) { _this.selectIntervalValues[x] = { key: String(x), text: String(x), selected: null }; });
        this.translate.get('INTERVAL_DAY').subscribe(function (text) {
            _this.selectIntervalValues[Interval.DAY].text = text;
        });
        this.translate.get('INTERVAL_WEEK').subscribe(function (text) {
            _this.selectIntervalValues[Interval.WEEK].text = text;
        });
        this.translate.get('INTERVAL_TWO_WEEK').subscribe(function (text) {
            _this.selectIntervalValues[Interval.TWO_WEEK].text = text;
        });
    };
    return CreateReservationIntervalComponent;
}());
export { CreateReservationIntervalComponent };
var Interval;
(function (Interval) {
    Interval[Interval["DAY"] = 0] = "DAY";
    Interval[Interval["WEEK"] = 1] = "WEEK";
    Interval[Interval["TWO_WEEK"] = 2] = "TWO_WEEK";
})(Interval || (Interval = {}));
